module.exports = "/images/water.svg?c295042975717a3f0e52f3cda4aa5147";